var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStairs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94394 2.35986L6.14097 3.31696V6.25574L3.44159 6.8744V9.81345L0.742188 10.4321V13.935L6.21497 17.6405L6.41459 17.5948L15.4167 15.4461V6.0656L9.94394 2.35986ZM5.96966 16.4151L1.64725 13.4886V11.4539L5.96966 14.4025V16.4151ZM6.38028 13.8859L2.14794 10.9989L3.97328 10.5804L8.20566 13.4678L6.38028 13.8859ZM8.66906 12.987L4.34666 10.0384V7.89615L8.66906 10.8448V12.987ZM9.07969 10.3282L4.84731 7.44086L6.67237 7.02273L10.9051 9.91036L9.07969 10.3282ZM11.3684 9.42958L7.04603 6.48089V4.33847L11.3684 7.2874V9.42958ZM11.7791 6.77105L7.54641 3.88366L9.75575 3.29174L14.0118 6.17394L11.7791 6.77105Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairs);
export default __webpack_public_path__ + "static/media/stairs.c286c22ab7e961c9a29c07c7c2dec481.svg";
export { ForwardRef as ReactComponent };